export default __webpack_public_path__ + "6d23f011554e8851463558466df0862b.png";